import React, { FunctionComponent, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { Button, Modal, SvgImage } from '../../../../../../shared/components';
import { PngImage } from '../../../../../../shared/components/png-image';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../../../../../shared/features/flags/selectors';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { countMetrika } from '../../../../../../shared/helpers/metrika';
import { SummarizationModalProps } from '../../types';
import styles from './styles.css';

export const SummarizationWelcomeModal: FunctionComponent<SummarizationModalProps> = ({ onClose: closeModal }) => {
    useEffect(() => countMetrika('meeting_screen', 'summarization', 'welcome_popup_was_shown'), []);

    const icon = <SvgImage imageName="close" />;
    const onClose = () => closeModal?.({ isConfirmed: false });
    const onConfirm = () => closeModal?.({ isConfirmed: true });
    const isCalendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);

    return (
        <Modal visible onClose={onClose}>
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <PngImage name="summarizationWelcome" className={styles.image} />
                        <div className={styles.title}>{i18n('summarization', 'welcome-dialog-title-v3')}</div>
                        <Button icon={icon} className={styles.closeButton} onClick={onClose} />
                    </div>
                    <div className={styles.content}>
                        {i18n(
                            'summarization',
                            isCalendarSummarizationFeatureEnabled
                                ? 'welcome-dialog-content-v3'
                                : 'welcome-dialog-content-v2'
                        )}
                    </div>
                    <div className={styles.footer}>
                        <Button view="brand" size="md" onClick={onConfirm}>
                            {i18n('summarization', 'welcome-dialog-submit')}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
